<template>
    <V2ReservationManagement/>
</template>


<script>
import V2ReservationManagement from '../../Main/V2ReservationManagement/V2ReservationManagement.vue'

export default {
    components: { V2ReservationManagement },
    mounted() {},
    methods: {}
}
</script>